<template>
    <div class="page marginCenter">
        <h2 class="center marginBom30">{{ query.announcementTitle }}</h2>
        <p class="fsize16 marginBom30">{{ query.announcementContent }}</p>
        <img v-if="query.announcementAtt" :src="query.announcementAtt" alt="" class="pointer" @click="downLoadFile(query.announcementAtt,query.announcementTitle)">
        <div class="flex-xCenter marginTop24 marginBom48"><el-button class="btn blueBtn2" @click="$router.go(-1)">返回</el-button></div>
    </div>
</template>
<script>
import {downLoadFile} from '@/utils/myUtil'
export default {
    data() {
        return {
            query:{}
        }
    },
    created(){
        this.query=this.$route.query
    },
    methods:{
        downLoadFile(url,name){
            downLoadFile(url,name)
        }
    }
}
</script>
<style lang="scss" scoped>
.btn{
    position: fixed;
    bottom: 100px;
    width: 200px;
}
</style>